import React from "react";
import * as Scrivito from "scrivito";
import cx from "classnames";
import s from "components/ProductConfigurator/ProductConfigurator.module.scss";
import stylesMain from "../../ProductConfigurationResultMainView.module.scss";
import { useProductOutput } from "stores/product";
import { Property } from "./SubComponents/Property";
import { ExpandableSection } from "components/ProductConfigurator/components/Results/components/ExpandableSection";
import { useTranslate } from "hooks";

export const TechnicalResults = Scrivito.connect(
  ({
    headerStyles,
    propertyStyles,
  }: {
    headerStyles?: string;
    propertyStyles?: string;
  }) => {
    const translate = useTranslate();
    const productOutput = useProductOutput();
    const outputs = productOutput?.product?.outputs;

    return (
      <ExpandableSection
        title={translate.stringOnly("PRODUCT_CONFIGURATOR_RESULTS")}
        classNames={cx(
          stylesMain.resultsCell,
          "d-flex flex-column flex-grow-1 border rounded bg-white" +
            " p-1 m-2" +
            " p-xxl-2 m-xxl-3" +
            " m-xxxl-4 ms-xxxl-2 mb-xxxl-3 ",
        )}
      >
        <div className="position-relative px-4">
          {outputs?.map((output, index) => (
            <div key={index} className={cx("pt-2", s.cardInputSection)}>
              <h5 className={headerStyles}>{output?.presentation}</h5>
              {output?.properties?.map(
                (property) =>
                  property && (
                    <Property
                      key={property?.id}
                      property={property}
                      isValueEditable={false}
                      propertyStyles={propertyStyles}
                    />
                  ),
              )}
            </div>
          ))}
        </div>
      </ExpandableSection>
    );
  },
);
